const { hostname } = window.location;
let apiBaseUrl = `https://${hostname}/`;
if (hostname === 'localhost') {
  apiBaseUrl = process.env.REACT_APP_MAIN_URL;
}
const suffixName = apiBaseUrl
  ?.split('//')[1]
  ?.replaceAll('/', '')
  ?.replaceAll('.', '_');

export const APP_USER_PROFILE = `${suffixName}_B2B_USER_PROFILE`;
export const APP_CONFIG = `${suffixName}_B2B_CONFIG`;
export const APP_USER_AUTH = `${suffixName}_B2B_USER_AUTH`;
export const APP_SWITCHBACK_AUTH_TOKEN = `${suffixName}_B2B_SWITCHBACK_AUTH_TOKEN`;
export const APP_SWITCHBACK_USER_PROFILE = `${suffixName}_B2B_SWITCHBACK_USER_PROFILE`;
export const APP_USER_ADDITIONAL_SETTINGS = `${suffixName}_B2B_USER_ADDITIONAL_SETTINGS`;
export const APP_COMPLETE_PROFILE = `${suffixName}_B2B_COMPLETE_PROFILE`;
export const APP_ADMIN_MESSAGE = `${suffixName}_B2B_ADMIN_MESSAGES`;
export const APP_PREF_LANGUAGE = `${suffixName}_B2B_PREF_LANGUAGE`;
export const APP_TIME_STAMP = `${suffixName}_B2B_TIME_STAMP`;
export const APP_TRAIN_RETURN_BOOKING = `${suffixName}_B2B_TRAIN_RETURN_BOOKING`;
export const APP_WEB_URL = apiBaseUrl;
export const APP_MAIN_URL = `${suffixName}_MAIN_URL`;
export const APP_LOGO_URL = `${suffixName}_LOGO_URL`;
export const APP_AGENT_LOGO_URL = `${suffixName}_AGENT_LOGO_URL`;
export const APP_LOADER_URL = `${suffixName}_LOADER_URL`;
export const APP_PASSPHRASE = 'BCLF34DUyOcZROnw';
export const APP_IV = 'ed25221a5effc60ee16c00cee8c85017';
export const GOOGLE_MAP_KEY = 'AIzaSyDh1Zoc7hX7m6iaTii9if3ANmt_7JqzY9Y';

export const APP_CUSTOMIZATIONS = `${suffixName}_APP_CUSTOMIZATIONS`;
